import React from 'react';
import { ContentLayout } from 'layout/content';
import { DossierValidated } from 'pods/dossier/validated';
export const DossierValidatedScene = () => {
    return (React.createElement(ContentLayout, null,
        React.createElement(DossierValidated, null)));
};
